<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col sm="1">
          <h5 class="mt-3 text-center">#{{ index + 1 }}</h5>
        </b-col>
        <b-col sm="8">
          <p v-if="item.fieldName && item.fieldName.length > 0" class="mt-1 mb-1"><b>{{$t('views.excmcasetype.form.customField.fieldName')}}</b>: {{ item.fieldName }}</p>
          <p v-if="item.fieldType === 'inputFormatted' && item.fieldDefaultValue && item.fieldDefaultValue.length > 0" class="mt-1 mb-1"><b>{{$t('views.excmcasetype.form.customField.fieldDefaultValue')}}</b>: <span v-html="item.fieldDefaultValue"></span></p>
          <p v-else-if="item.fieldDefaultValue && item.fieldDefaultValue.length > 0" class="mt-1 mb-1"><b>{{$t('views.excmcasetype.form.customField.fieldDefaultValue')}}</b>: {{ item.fieldDefaultValue }}</p>
          <p v-if="item.fieldDescription && item.fieldDescription.length > 0" class="mt-1 mb-1"><b>{{$t('views.excmcasetype.form.customField.fieldDescription')}}</b>: {{ item.fieldDescription }}</p>
          <p v-if="item.fieldLabel && item.fieldLabel.length > 0" class="mt-1 mb-1"><b>{{$t('views.excmcasetype.form.customField.fieldLabel')}}</b>: {{ item.fieldLabel }}</p>
          <p class="mt-1 mb-1">
            <b>{{$t('views.excmcasetype.form.customField.fieldReadonly')}}</b>: <span v-if="item.fieldReadonly == 0">{{ $t('buttons.no') }}</span>
            <span v-else-if="item.fieldReadonly == 1">{{ $t('buttons.yes') }}</span>
          </p>
          <p class="mt-1 mb-1">
            <b>{{$t('views.excmcasetype.form.customField.fieldRequired')}}</b>: <span v-if="item.fieldRequired == 0">{{ $t('buttons.no') }}</span>
            <span v-else-if="item.fieldRequired == 1">{{ $t('buttons.yes') }}</span>
          </p>
          <p v-if="item.fieldType === 'input'" class="mt-1 mb-1">
            <b>{{$t('views.excmcasetype.form.customField.onlyNumbersAllowed')}}</b>: <span v-if="item.onlyNumbersAllowed == 0">{{ $t('buttons.no') }}</span>
            <span v-else-if="item.onlyNumbersAllowed == 1">{{ $t('buttons.yes') }}</span>
          </p>
          <p v-if="item.fieldType === 'input' && item.onlyNumbersAllowed && item.minValue !== null && item.minValue !== ''" class="mt-1 mb-1">
            <b>{{$t('views.excmcasetype.form.customField.minValue')}}</b>: <span>{{ item.minValue }}</span>
          </p>
          <p v-if="item.fieldType === 'input' && item.onlyNumbersAllowed && item.maxValue !== null && item.maxValue !== ''" class="mt-1 mb-1">
            <b>{{$t('views.excmcasetype.form.customField.maxValue')}}</b>: <span>{{ item.maxValue }}</span>
          </p>
          <template v-if="item.fieldType === 'datetime'">
            <p v-if="item.allowedDaysAhead" class="mt-1 mb-1"><b>{{$t('views.excmcasetype.form.customField.allowedDaysAhead')}}</b>: {{ item.allowedDaysAhead }}</p>
            <p v-if="item.allowedDaysBack" class="mt-1 mb-1"><b>{{$t('views.excmcasetype.form.customField.allowedDaysBack')}}</b>: {{ item.allowedDaysBack }}</p>
          </template>
          <p v-if="item.fieldType && item.fieldType.length > 0" class="mt-1 mb-1"><b>{{$t('views.excmcasetype.form.customField.fieldType')}}</b>: {{ item.fieldType }}</p>
        </b-col>
        <b-col sm="3">
          <b-button class="btn btn-success float-right mt-0 mb-1" size="sm" @click="edit()">{{ $t('buttons.edit') }}</b-button>
          <b-button class="btn btn-warning float-right mt-0 mb-0" size="sm" @click="archive()" v-if="item['@id'] && item.state === 1">{{ $t('buttons.archive') }}</b-button>
          <b-button class="btn btn-warning float-right mt-0 mb-0" size="sm" @click="moveFromArchive()" v-else-if="item['@id'] && item.state === 0">{{ $t('buttons.moveFromArchive') }}</b-button>
          <b-button class="btn btn-danger float-right mt-0 mb-0" size="sm" @click="removeItem()">{{ $t('buttons.delete') }}</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <hr class="mt-1 mb-1">
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import getId from '@/utils/getIdFromLink'
import { mapActions, mapGetters } from 'vuex'
import remove from '@/utils/remove'
export default {
  name: 'CustomField',
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    // violations: {
    //   type: Object,
    //   required: true
    // },
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      routeName: '',
      showCollapse: false
    }
  },
  created () {
    this.routeName = this.$route.name
    if (this.routeName === 'EXCMCaseTypeShow' || this.routeName === 'EXCMTaskTypeShow') {
      this.itemPusher = this.$store.state.Pusher.subscribe('e_x_c_m_custom_fields-' + this.getIdLink(this.item['@id']))
      this.itemPusher.bind('e_x_c_m_custom_fields-' + this.getIdLink(this.item['@id']), data => {
        this.getCustomField(this.getIdLink(this.item['@id']))
      })
    }
  },
  destroyed () {
    if (this.routeName === 'EXCMCaseTypeShow' || this.routeName === 'EXCMTaskTypeShow') {
      this.$store.state.Pusher.unsubscribe('e_x_c_m_custom_fields-' + this.getIdLink(this.item['@id']))
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'excmcustomfield/update/isLoading',
      error: 'excmcustomfield/update/error',
      deleteError: 'excmcustomfield/del/error',
      deleteLoading: 'excmcustomfield/del/isLoading',
      created: 'excmcustomfield/create/created',
      deleted: 'excmcustomfield/del/deleted',
      retrieved: 'excmcustomfield/update/retrieved',
      updated: 'excmcustomfield/update/updated',
      violations: 'excmcustomfield/update/violations'
    })
  },
  methods: {
    ...mapActions({
      createReset: 'excmcustomfield/create/reset',
      deleteItem: 'excmcustomfield/del/del',
      delReset: 'excmcustomfield/del/reset',
      retrieve: 'excmcustomfield/update/retrieve',
      updateReset: 'excmcustomfield/update/reset',
      update: 'excmcustomfield/update/update',
      updateRetrieved: 'excmcustomfield/update/updateRetrieved'
    }),
    getCustomField (id) {
      this.$http
        .get('api/e_x_c_m_custom_fields/' + id)
        .then(response => {
          this.item = response.data
        })
        .catch(error => {
          this.$Swal({
            title: error,
            type: 'error'
          })
        })
    },
    removeItem () {
      if (this.item['@id']) {
        remove(this.item['@id'], () => {
          this.items.splice(this.index, 1)
        })
      } else {
        this.items.splice(this.index, 1)
      }
    },
    edit () {
      this.$store.state.modals.customField.update.show = 1
      this.$store.state.modals.customField.update.customFieldObject = this.item
      this.$store.state.modals.customField.update.index = this.index
    },
    getIdLink (link) {
      return getId(link)
    },
    archive () {
      // let item = Object.assign({}, this.item)
      this.item.state = 0
      this.$store.state.excmcustomfield.update.retrieved = this.item
      this.update()
    },
    moveFromArchive () {
      this.item.state = 1
      this.$store.state.excmcustomfield.update.retrieved = this.item
      this.update()
    }
  }
}
</script>
